import { Col, ControlLabel, FormControl, FormGroup, Row } from "react-bootstrap";
import { compose, pure, withHandlers, withState } from "recompose";

import Cleave from 'cleave.js/react';

import Card from "../Card/Card.jsx";
import { injectIntl, FormattedMessage, intlShape } from "react-intl";
import Queries from "../../queries/queries2";
import React from "react";
import NumberFormat from "react-number-format";
import Select from "react-select-plus";

import _ from "lodash";
import { graphql } from "react-apollo";


const idemLoaded = withState("idemLoaded", "setIdemLoaded", false);

// const handlers = withHandlers({
//   onIdemCheck: ({ defaultTaxes, onChange, setIdemLoaded }) => value => {
//     if (value) {
//       onChange("tax1", defaultTaxes.company.tax1);
//       onChange("tax2", defaultTaxes.company.tax2);
//       onChange("taxIdemCompany", true);
//       setIdemLoaded(true);
//     } else {
//       onChange("taxIdemCompany", false);
//     }
//   }
// });

const TiersXtraDataCard = ({
  companyId,
  onChange,
  taxableValue,
  externalCodeValue,
  escomptePercentValue,
  intl
}) => {

  // console.log("36 - taxableValue=", taxableValue)
  let selectedValued = taxableValue;

  const options =
    [
      // {
      //   value: "TAXABLE",              TAXABLE NO LONGUER EXISTS
      //   label: intl.formatMessage({ id: "ids_taxable" })
      // },
      {
        value: "NON_TAXABLE",
        label: intl.formatMessage({ id: "ids_nonTaxable" })
      },
      {
        value: "ENCAISSEMENT",
        label: intl.formatMessage({ id: "ids_encaissement" })
      },
      {
        value: "SUR_LES_DEBITS",
        label: intl.formatMessage({ id: "ids_debit" })
      },
      {
        value: "A_L_EXPORT",
        label: intl.formatMessage({ id: "ids_aLExport" })
      },
      {
        value: "INTRACOMMUNAUTAIRE",
        label: intl.formatMessage({ id: "ids_intracommunautaire" })
      },
      {
        value: "AUTO_LIQUIDATION",
        label: intl.formatMessage({ id: "ids_autoLiquidation" })
      }
    ];

  const Component = Select;

  // console.log("78 - Component=", Component);

  return (
    <Card title={<FormattedMessage id="ids_extraParameters" />}>
      {/* <Row>
        <Col xs={6}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage id="ids_taxable" />
            </ControlLabel>

            <Component
              clearable={false}
              value={selectedValued}
              onChange={e => {
                onChange("taxableValue", e && e.value);
              }}
              options={options}
            />
          </FormGroup>
        </Col>
      </Row> */}

      <Row>
        <Col xs={6}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage id='ids_externalCode' />
            </ControlLabel>
            <FormControl
              placeholder="XCL000"
              name="externalCode"
              value={externalCodeValue}
              onChange={(e) => onChange("externalCodeValue", e.target.value)} />
          </FormGroup>
        </Col>
        <Col xs={6}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage id='ids_escomptePercent' />
            </ControlLabel>
            <NumberFormat
              allowNegative={false}
              className="form-control"
              value={escomptePercentValue}
              decimalScale={2}
              displayType="input"
              fixedDecimalScale={true}
              decimalSeparator={"."}
              thousandSeparator={true}
              onChange={e => onChange("escomptePercentValue", parseFloat(e.target.value))}
            />
          </FormGroup>
        </Col>
      </Row>
    </Card>
  );
};

export default compose(
  idemLoaded,
  // handlers,
  injectIntl,
  pure
)(TiersXtraDataCard);
